export const UPDATE_ALL_SHOP = 'UPDATE_ALL_SHOP';